import { createSlice } from '@reduxjs/toolkit';

export interface ApiKey {
  apiKey: string;
}

const initialState: ApiKey = {
  apiKey: process.env.REACT_APP_DEFAULT_API_KEY,
};

export const apiKeySlice = createSlice({
  name: 'userApiKey',
  initialState,
  reducers: {
    setDefaultApiKey: (state, action) => {
      state.apiKey = action.payload;
    },
  },
});

export const { setDefaultApiKey } = apiKeySlice.actions;

export default apiKeySlice.reducer;
